import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import AddCircle from "@material-ui/icons/AddCircle";
import Block from "@material-ui/icons/Block";
import Avatar from "@material-ui/core/Avatar/Avatar";
import Person from "@material-ui/icons/Person";
import CancellationListTableActions from "./components/table-action";
import SearchField from "../components/search-field";
import { useCancellationStyles } from "../styles";
import { useCancellationListStyles } from "./styles";
import CustomPagination from "../../../Components/pagination";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import EmptyState from "../../../Components/EmptyState";
import { usePermission } from "../../../hooks/usePermission";
import { useCancellationList } from "../../../services/api-tansquery/cancellation/list";
import { extractDateFormat } from "../../../utils/dateFormat";

export default function AppointmentCancellationsList() {
  const history = useHistory();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { pathname } = useLocation();
  const { isAboveCoordenator } = usePermission();
  const { classes } = useCancellationListStyles();
  const { classes: defaultClasses } = useCancellationStyles();
  const { data: cancellationList, isLoading } = useCancellationList();

  const isEmpty = (cancellationList?.results ?? []).length === 0;

  useEffect(() => {
    setBreadcrumbs((prev) => {
      const homeBreadcrumb = prev.find((_, index) => index === 0);
      return [
        homeBreadcrumb,
        {
          label: "Cancelamentos",
          path: "/cancelamentos",
          icon: Block,
        },
      ];
    });
  }, [setBreadcrumbs]);

  return (
    <Box>
      <Box className={classes.header}>
        <Typography className={classes.title}>
          Cancelamentos de Agendamentos
        </Typography>
        {isAboveCoordenator && (
          <Button
            startIcon={<AddCircle />}
            className={defaultClasses.addButton}
            onClick={() => history.push(`${pathname}/novo`)}
          >
            Novo Cancelamento
          </Button>
        )}
      </Box>
      <Paper elevation={3}>
        <SearchField placeholder="Buscar por título ou responsável..." />
        <TableContainer className={defaultClasses.tableContainer}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className={defaultClasses.tableTH}>
                  Título
                </TableCell>
                <TableCell className={defaultClasses.tableTH}>
                  Criado por
                </TableCell>
                <TableCell className={defaultClasses.tableTH}>
                  Ativo
                </TableCell>
                <TableCell className={defaultClasses.tableTH}>
                  Data
                </TableCell>
                <TableCell className={defaultClasses.tableTH} />
              </TableRow>
            </TableHead>
            <TableBody>
              {cancellationList?.results.map((cancellation) => (
                <TableRow key={cancellation.id} hover>
                  <TableCell className={defaultClasses.tableCell}>
                    {cancellation.titulo}
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    <Box display="flex" alignItems="center">
                      <Avatar
                        style={{
                          width: 24,
                          height: 24,
                          marginRight: 8,
                        }}
                      >
                        <Person style={{ color: "#fff", width: 18, height: 18 }} />
                      </Avatar>
                      {cancellation.user?.first_name}{" "}
                      {cancellation.user?.last_name}
                    </Box>
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    <Box
                      className={`${defaultClasses.badge} ${cancellation.ativo
                        ? defaultClasses.active
                        : defaultClasses.inactive
                        }`}
                    >
                      {cancellation.ativo ? "Sim" : "Não"}
                    </Box>
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    {extractDateFormat(cancellation.data)}
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    <CancellationListTableActions
                      id={cancellation.id}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {isEmpty && (
            <EmptyState
              loading={isLoading}
              loadingText="Carregando cancelamentos..."
              message="Nenhum cancelamento de agendamento encontrado."
            />
          )}
        </TableContainer>
        <Box className={defaultClasses.paginationContainer}>
          <CustomPagination
            count={cancellationList?.count}
            page={cancellationList?.current}
            totalPages={cancellationList?.total_pages}
          />
        </Box>
      </Paper>
    </Box>
  );
}
